
define('ldsh!modules/form_editor/templates/editor_advanced_variable', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="editor-form-group ed-form-group ed-advanced-item">\n  <label class="control-label" for="" data-i18n="[text]formEditor.hiddenFieldVariableFromQuery">Variable</label>\n  <input type="text" class="form-control js-variable" value="' +
((__t = ( variable )) == null ? '' : __t) +
'">\n</div>\n';

}
return __p
};});

